<template>
	<div class="">
		<div class="banners">
			<div class="main-container">
				<div class="">
					<div class="sidebar">
						<!-- <Sidebar/> -->
						<MainSidebar @sidebar-toggled="onSidebarToggled" />
					</div>
					<ProductToolbar />
					<div class="content" :style="contentStyle">
						<div class="row">
							<div class="col">
								<router-view />
							</div>
						</div>
					</div>
					<v-idle
						@idle="onidle"
						@remind="onremind"
						:duration="idleDuration"
						:reminders="[300, 600]"
						:loop="false"
						style="display:none;"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	// import Sidebar from '../components/Sidebar.vue';
	import MainSidebar from '../components/MainSidebar.vue';
	import ProductToolbar from '../components/ProductToolbar.vue';

	export default {
		data() {
			return {
				isSidebarExpanded: window.innerWidth >= 992,
				idleDuration: 1200, // 20 minutes (increased from 720s)
				tokenRefreshInterval: null,
			}
		},

		components: {
			// Sidebar,
			MainSidebar,
			ProductToolbar
		},

		created() {
			// The new sidebar handles its own responsive logic, so we can remove the old listeners.
		},

		mounted() {
			// Periodically verify and refresh token if token expiry time is less than idle time or approaching expiry
			this.checkAndRefreshToken();
			this.tokenRefreshInterval = setInterval(() => {
				this.checkAndRefreshToken();
			}, 60000);
		},

		beforeUnmount() {
			if (this.tokenRefreshInterval) {
				clearInterval(this.tokenRefreshInterval);
				this.tokenRefreshInterval = null;
			}
		},

		methods: {
			onSidebarToggled(isExpanded) {
				this.isSidebarExpanded = isExpanded;
			},

			async checkAndRefreshToken() {
				if (!this.$store.state.auth || !this.$store.state.auth.authenticated || !this.$store.state.auth.accessToken) {
					return;
				}

				const remainingSeconds = this.$helper ? this.$helper.getTokenRemainingSeconds() : 0;
				// If remaining token time is 5 minutes or less (300s) and token exists, refresh token proactively
				if (remainingSeconds > 0 && remainingSeconds <= 300) {
					try {
						await this.$token.refreshToken();
					} catch (error) {
						console.error("Token refresh failed during idle check:", error);
					}
				}
			},

			async onremind() {
				await this.checkAndRefreshToken();
			},

			onidle(){
				this.$store.commit('auth/setTokenExpires');
				this.$store.dispatch('auth/logout', { logoutAuth: false, isIdle: true });
			}
		},
		computed: {
			contentStyle() {
				// On mobile, the sidebar overlays content, so no margin is needed.
				if (window.innerWidth <= 768) {
					return { marginLeft: '0px' };
				}
				// On desktop, adjust margin based on sidebar state.
				const sidebarWidth = this.isSidebarExpanded ? '260px' : '70px';
				return { marginLeft: sidebarWidth };
			},
		}
	}
</script>

<style scoped>
.content {
	padding-top: 66px; /* Height of the header */
	transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	padding-left: 50px; /* Add some padding for content */
	padding-right: 15px;
}
</style>